import React, { useMemo } from 'react';
import { Redirect, useParams } from 'react-router-dom';

export const CompanyOnboarding = () => {
  const { networkSlug, employerSlug } = useParams();

  // if confirmation token is present, redirect to claim your profile
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  if (params.get('confirmation_token')) {
    return <Redirect to={`/claim-your-profile/${networkSlug}/company/${employerSlug}?${params.toString()}`} />;
  }

  return <Redirect to={`/networks/${networkSlug}/company/${employerSlug}/welcome${window.location.search}`} />;
};
